import React, {useEffect} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import {
    cancelReferralTransfer,
    cancelReferralWithdraw,
    getDashboard,
    getReferrals,
    getReferralTransfers,
    getReferralWithdraws,
    getUserData,
    setReferralTransfersModalStatus
} from "../../../store/cabinet/action";
import {amountHandler, dateTimeHandler} from "../../../helpers/capsule";

// Внутренний баланс приходит без валюты — тикер берём из макета
const BALANCE_CURRENCY = '$TC';

// Статусы вывода — те же, что у вывода основного баланса
const WITHDRAW_STATUS_LABEL = {
    pending: 'Ожидает подтверждения',
    approved: 'Отправляем',
    broadcasted: 'Отправлено в сеть',
    sent: 'Выплачено',
    rejected: 'Отклонено',
    cancelled: 'Отменено',
    failed: 'Не прошло'
};

// Перевод на основной баланс — легаси: новые не создаются, старые можно отменить
const TRANSFER_STATUS_LABEL = {
    pending: 'Ожидает подтверждения',
    approved: 'Зачислено',
    rejected: 'Отклонено',
    cancelled: 'Отменено'
};

const CabinetApostolTransfersModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const modalStatus = useSelector(store => store.cabinet.referralTransfersModalStatus);
    const withdrawsData = useSelector(store => store.cabinet.referralWithdraws);
    const withdrawsStarted = useSelector(store => store.cabinet.referralWithdrawsStarted);
    const cancelWithdrawStarted = useSelector(store => store.cabinet.cancelReferralWithdrawStarted);
    const transfers = useSelector(store => store.cabinet.referralTransfers);
    const cancelTransferStarted = useSelector(store => store.cabinet.cancelReferralTransferStarted);

    useEffect(()=>{
        if (modalStatus){
            dispatch(getReferralWithdraws());
            // старые заявки на перевод ещё живут и их можно отменить
            dispatch(getReferralTransfers());
        }
    },[modalStatus, dispatch])

    const closeModal = () => {
        dispatch(setReferralTransfersModalStatus(false));
    };

    const refreshHandler = () => {
        dispatch(getReferralWithdraws());
        dispatch(getReferralTransfers());
        dispatch(getReferrals());
        dispatch(getUserData());
        dispatch(getDashboard());
    };

    const cancelWithdrawHandler = (id) => {
        if (cancelWithdrawStarted){
            return;
        }
        dispatch(cancelReferralWithdraw(id, refreshHandler));
    };

    const cancelTransferHandler = (id) => {
        if (cancelTransferStarted){
            return;
        }
        dispatch(cancelReferralTransfer(id, refreshHandler));
    };

    const withdraws = withdrawsData?.withdrawals || [];
    const legacyTransfers = Array.isArray(transfers) ? transfers : [];
    const isEmpty = !withdrawsStarted && !withdraws.length && !legacyTransfers.length;

    const statusClass = (status) => {
        if (status === 'sent' || status === 'approved' || status === 'broadcasted') {
            return Styles.listStatusOk;
        }
        if (status === 'pending') {
            return Styles.listStatusWait;
        }
        return Styles.listStatusOff;
    };

    return (
        <Popup
            open={modalStatus}
            modal
            nested
            className="capsuleModal"
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalCloseBtn}`} onClick={closeModal}>
                    <div/>
                    <div/>
                </div>

                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalHead}`}>
                        <div className={`${Styles.modalTitle}`}>{t('История выплат')}</div>
                        <div className={`${Styles.modalNote}`}>
                            {t('Заявки на вывод вознаграждений')}
                        </div>
                    </div>

                    <div className={`${Styles.modalBody}`}>
                        {withdrawsStarted && !withdraws.length ? (
                            <div className={`${Styles.emptyNote}`}>{t('Загружаем…')}</div>
                        ) : null}

                        {isEmpty ? (
                            <div className={`${Styles.emptyNote}`}>
                                {t('Заявок пока нет')}
                            </div>
                        ) : null}

                        {withdraws.length ? (
                            <div className={`${Styles.listWrap}`}>
                                {withdraws.map((item)=>{
                                    return (
                                        <div className={`${Styles.listItem}`} key={'referral-withdraw_' + item?.id}>
                                            <div className={`${Styles.listHead}`}>
                                                <span className={`${Styles.listAmount}`}>
                                                    {amountHandler(item?.amount)} {BALANCE_CURRENCY}
                                                </span>
                                                <span className={`${Styles.listStatus} ${statusClass(item?.status)}`}>
                                                    {t(WITHDRAW_STATUS_LABEL[item?.status] || 'Заявка')}
                                                </span>
                                            </div>

                                            {item?.token_amount ? (
                                                <div className={`${Styles.listRow}`}>
                                                    <span>{t('На кошелёк')}</span>
                                                    <span className={`${Styles.listValue}`}>
                                                        {item.token_amount} {item?.token_symbol || ''}
                                                    </span>
                                                </div>
                                            ) : null}

                                            <div className={`${Styles.listRow}`}>
                                                <span>{t('Создана')}</span>
                                                <span className={`${Styles.listValue}`}>{dateTimeHandler(item?.created_at)}</span>
                                            </div>

                                            {item?.sent_at ? (
                                                <div className={`${Styles.listRow}`}>
                                                    <span>{t('Выплачено')}</span>
                                                    <span className={`${Styles.listValue}`}>{dateTimeHandler(item?.sent_at)}</span>
                                                </div>
                                            ) : null}

                                            {item?.admin_comment || item?.failure_reason ? (
                                                <div className={`${Styles.listComment}`}>
                                                    {item.admin_comment || item.failure_reason}
                                                </div>
                                            ) : null}

                                            {item?.explorer_url ? (
                                                <a
                                                    className={`${Styles.listLink}`}
                                                    href={item.explorer_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {t('Смотреть транзакцию')}
                                                </a>
                                            ) : null}

                                            {item?.status === 'pending' ? (
                                                <div
                                                    className={`${Styles.listBtn} ${cancelWithdrawStarted ? Styles.listBtnDsb : ''}`}
                                                    onClick={()=>{cancelWithdrawHandler(item?.id)}}
                                                >
                                                    {cancelWithdrawStarted ? t('Отменяем…') : t('Отменить заявку')}
                                                </div>
                                            ) : null}
                                        </div>
                                    )
                                })}
                            </div>
                        ) : null}

                        {legacyTransfers.length ? (
                            <div className={`${Styles.listWrap} ${Styles.listWrapLegacy}`}>
                                <div className={`${Styles.listLegacyName}`}>
                                    {t('Переводы на основной баланс')}
                                </div>

                                {legacyTransfers.map((item)=>(
                                    <div className={`${Styles.listItem}`} key={'referral-transfer_' + item?.id}>
                                        <div className={`${Styles.listHead}`}>
                                            <span className={`${Styles.listAmount}`}>
                                                {amountHandler(item?.amount)} {BALANCE_CURRENCY}
                                            </span>
                                            <span className={`${Styles.listStatus} ${statusClass(item?.status)}`}>
                                                {t(TRANSFER_STATUS_LABEL[item?.status] || 'Заявка')}
                                            </span>
                                        </div>

                                        <div className={`${Styles.listRow}`}>
                                            <span>{t('Создана')}</span>
                                            <span className={`${Styles.listValue}`}>{dateTimeHandler(item?.created_at)}</span>
                                        </div>

                                        {item?.admin_comment ? (
                                            <div className={`${Styles.listComment}`}>{item.admin_comment}</div>
                                        ) : null}

                                        {item?.status === 'pending' ? (
                                            <div
                                                className={`${Styles.listBtn} ${cancelTransferStarted ? Styles.listBtnDsb : ''}`}
                                                onClick={()=>{cancelTransferHandler(item?.id)}}
                                            >
                                                {cancelTransferStarted ? t('Отменяем…') : t('Отменить заявку')}
                                            </div>
                                        ) : null}
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </div>

                    <div className={`${Styles.modalFooter}`}>
                        <div className={`${Styles.modalBtn} ${Styles.modalBtnWide}`} onClick={closeModal}>
                            {t('Закрыть')}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetApostolTransfersModal;
